import {useMutation} from '@tanstack/react-query';
import ChessRestClient from '@/Api/ChessRestClient';

type updateChapterSettingsType = {
  chapter_id: number;
  // 'hide_moves' is only ever read back for chapters saved before
  // `conceal_moves` existed as an independent toggle - new writes should use
  // `conceal_moves` instead of this value.
  chapter_mode?: 'analysis' | 'lesson' | 'practice' | 'hide_moves';
  conceal_moves?: boolean;
  orientation?: 'W' | 'B';
  name?: string;
  description?: string;
  practice_goal?: {type: string; value?: number} | null;
  // Practice-mode opponent strength as a target Elo. null = full strength.
  practice_difficulty?: number | null;
  // Whether the student may retune that strength. null = 'free', the
  // behaviour of every chapter authored before this setting existed.
  practice_strength_policy?: 'fixed' | 'floor' | 'free' | null;
  // Take backs permitted per attempt. null = unlimited, 0 = none.
  practice_takebacks_allowed?: number | null;
  // The position the student plays out, picked by the coach from anywhere in
  // the chapter's move tree. null = the chapter's own starting position.
  practice_start_fen?: string | null;
  // Which colour the STUDENT plays. null = fall back to `orientation`, which
  // is how every chapter authored before this setting existed behaves.
  practice_player_color?: 'w' | 'b' | null;
};

export default function useUpdateChapterSettings() {
  return useMutation(async (payload: updateChapterSettingsType) => {
    const response = await ChessRestClient.post(
      'learning/study_chapter/update_settings/',
      payload,
    );
    return response.data;
  });
}
